"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathHelper = void 0;
var MathHelper = /** @class */ (function () {
    function MathHelper() {
    }
    MathHelper.featureScaling = function (value, min, max) {
        var notValid = false;
        [value, min, max].forEach(function (param) {
            if (typeof param !== "number") {
                notValid = true;
            }
        });
        if (notValid) {
            return NaN;
        }
        if (max === min && min === 0) {
            return 0;
        }
        if (max === min) {
            return 1;
        }
        return (value - min) / (max - min);
    };
    MathHelper.meanNormalized = function (value, values, max, min) {
        if (values.length === 0) {
            return 0;
        }
        var mean = values.reduce(function (prev, current) { return prev + current; }, 0) / values.length;
        return (value - mean) / (max - min);
    };
    MathHelper.round = function (value, precision) {
        if (precision === void 0) { precision = 0; }
        var multiplier = Math.pow(10, precision);
        return Math.floor(value * multiplier + 0.5) / multiplier;
    };
    return MathHelper;
}());
exports.MathHelper = MathHelper;
//# sourceMappingURL=MathHelper.js.map